module.exports = __webpack_public_path__ + "static/media/VGT_110.ad0445e5.png";